import ToolbarAction from './toolbar-action.element.js';

export default ToolbarAction;

ToolbarAction.define('wje-toolbar-action', ToolbarAction);
